import { VyIcon } from '@weft/icons';
import { raiseUnreachable } from '@weft/utils';
import type { FunctionComponent } from 'react';
import type { IconProps } from 'react-toastify';
import { TOAST_ICON_COLORS } from '../vy-toast-types';

export const VyToastIcon: FunctionComponent<IconProps> = ({ type }) => {
  switch (type) {
    case 'info':
    case 'default':
    case 'warning':
      return null;
    case 'error':
      return (
        <VyIcon
          icon="Error"
          color={TOAST_ICON_COLORS.ERROR}
        />
      );
    case 'success':
      return (
        <VyIcon
          icon="Success"
          color={TOAST_ICON_COLORS.SUCCESS}
        />
      );
    default:
      return raiseUnreachable(type);
  }
};